import React from "react";
import {useCore} from "../hooks";
import './OrderDraftColumn.css'
import {formatPrice} from "../utils";

export const OrderDraftSummary: React.FC = () => {
  const { currentOrder, currency } = useCore()

  return (
    <div className="w-full h-row flex items-center">
      <div className="flex justify-between w-full font-bold text-lg">
       <span>Cena:</span> <span>{formatPrice(currentOrder?.priceAll || 0, currency?.id)}</span>
      </div>
    </div>
  )
}
